import { Host, Component, Element, h, Prop } from '@stencil/core';
/**
 * COMPNAME is for creating a call-to-action donate button for AAFP Foundation pages
 *
 * Note that this button is essentially a wrapper for the default CTA button. The wrapper enables custom colors for the donate button.
 *
 * <em>For More Information:</em>
 * AEM Component- ui.apps/src/main/content/jcr_root/apps/brand/aafp/components/content/aafp-cta-button
 * Sling Model- core/src/main/java/org/aafp/aem/core/models/AafpCtaModel.java
 */
@Component({
  tag: 'aafp-donate-button',
  shadow: false,
})
export class AafpDonateButton {
  /**
   * For creating the target link
   */
  @Prop() href!: string;
  /**
   * For creating the cta's text
   */
  @Prop() label!: string;
  /**
   * For creating cta's aria label
   */
  @Prop() ariaLabel!: string | null;

  @Element() element: HTMLElement;

  render() {
    return (
      <Host class="adl-donate-button">
        <aafp-cta-button
          label={this.label}
          is-active="true"
          is-secondary="false"
          is-external-link="false"
          href={this.href}
          aria-label={this.ariaLabel}
        ></aafp-cta-button>
      </Host>
    );
  }
}
